import PropTypes from 'prop-types';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { jsx as _jsx } from "react/jsx-runtime";
(function () {
  if (typeof document === "undefined") {
    return;
  }
  const styles = ".kof-text-editor .ck-content {\n  min-height: 200px;\n}\n.kof-text-editor .heading-1 {\n  font-size: 22px;\n}\n.kof-text-editor .heading-2 {\n  font-size: 20px;\n}\n.kof-text-editor .heading-3 {\n  font-size: 18px;\n}\n.kof-text-editor .heading-4 {\n  font-size: 16px;\n}\n.kof-text-editor .heading-5 {\n  font-size: 14px;\n}";
  const fileName = "TextEditor_TextEditor_093857c4-4fc5-4a9e-b01f-fdb10b9b4058";
  const element = document.querySelector("style[data-sass-component='TextEditor_TextEditor_093857c4-4fc5-4a9e-b01f-fdb10b9b4058']");
  if (!element) {
    const styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();
function TextEditor(props) {
  const headingOptions = [{
    model: 'paragraph',
    title: 'Paragraph'
  }, {
    model: 'heading1',
    view: 'h1',
    title: 'Heading 1',
    class: 'heading-1'
  }, {
    model: 'heading2',
    view: 'h2',
    title: 'Heading 2',
    class: 'heading-2'
  }, {
    model: 'heading3',
    view: 'h3',
    title: 'Heading 3',
    class: 'heading-3'
  }, {
    model: 'heading4',
    view: 'h4',
    title: 'Heading 4',
    class: 'heading-4'
  }, {
    model: 'heading5',
    view: 'h5',
    title: 'Heading 5',
    class: 'heading-5'
  }, {
    model: 'container',
    view: 'div',
    title: 'Container'
  }];
  const createCustomHeadingConfig = () => {
    const customConfig = {
      options: []
    };
    props.headingConfigOptionNames.forEach(headingConfigOptionName => {
      const option = headingOptions.find(option => option.model === headingConfigOptionName);
      customConfig.options.push(option);
    });
    return customConfig;
  };
  const createHeadingConfig = () => {
    if (props.headingConfigOptionNames) {
      return createCustomHeadingConfig();
    }
    return {
      options: headingOptions
    };
  };
  return /*#__PURE__*/_jsx("div", {
    className: 'kof-text-editor',
    children: /*#__PURE__*/_jsx(CKEditor, {
      editor: ClassicEditor,
      config: {
        toolbar: ['heading', 'bold', 'numberedList', 'bulletedList', 'link'],
        heading: createHeadingConfig()
      },
      data: props.content,
      onChange: (event, editor) => {
        props.onChange(editor.getData());
      }
    })
  });
}
TextEditor.propTypes = {
  content: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  headingConfigOptionNames: PropTypes.array
};
export { TextEditor };